// extracted by mini-css-extract-plugin
var _1 = "HistoricalCommentThread-module__animateUploadProgressBarWidth--A4e0H";
var _2 = "HistoricalCommentThread-module__animatedBackground--q32Wi";
var _3 = "HistoricalCommentThread-module__context--VeBnd";
var _4 = "HistoricalCommentThread-module__outdatedText--d_SgW";
var _5 = "HistoricalCommentThread-module__reactionListContainer--zg5SU";
var _6 = "HistoricalCommentThread-module__resolvedText--k5EtM";
var _7 = "HistoricalCommentThread-module__resolverContainer--k5gcD";
var _8 = "HistoricalCommentThread-module__thread--yn6oM";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "context", _4 as "outdatedText", _5 as "reactionListContainer", _6 as "resolvedText", _7 as "resolverContainer", _8 as "thread" }
